import { render, staticRenderFns } from "./TrainingPartnerSpace.vue?vue&type=template&id=207408ae"
import script from "./TrainingPartnerSpace.vue?vue&type=script&lang=ts"
export * from "./TrainingPartnerSpace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports